import { replaceUrlHost } from '@osmosis/shared/url';
import { PROD_MEDIA_SERVER } from '@osmosis/constants';

/**
 * Replaces S3 URL with Cloudfront URL for better performance.
 */
export const replaceS3ToCloudfront = (url?: string) => {
  if (!url) return url;

  return replaceUrlHost(url, PROD_MEDIA_SERVER);
};
